import { render, staticRenderFns } from "./mainlandpackage-edit.vue?vue&type=template&id=0b44032f&"
import script from "./mainlandpackage-edit.vue?vue&type=script&lang=ts&"
export * from "./mainlandpackage-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports